import apiPaths from '../../api-paths';

export default {
    index(query = '') {
        return axios.get(`${ apiPaths.CRM }/mails${ query }`);
    },
    get(id) {
        return axios.get(`${ apiPaths.CRM }/mails/${ id }`);
    },
    getWithAttachments(id) {
      return axios.get(`${ apiPaths.CRM }/mails/${ id }/with-attachments`);
    },
    sendNow(id) {
        return axios.post(`${ apiPaths.CRM }/mails/${ id }/send-now`);
    },
    retrySend(id) {
        return axios.post(`${ apiPaths.CRM }/mails/${ id }/retry-failed`);
    },
    save(data, fromBaseParent = false) {
      const formData = new FormData();

      if(data.original) {
        formData.append('original', data.original);
      }
      if(data.id) {
        formData.append('id', data.id);
      }

      const dispatchTimeWithoutSeconds = new Date(data.dispatchTime).toLocaleString('sv', {
        year: 'numeric',
        month: '2-digit', 
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).replace(' ', ' ');

      formData.append('_method', 'PUT');
      formData.append('title', data.title);
      formData.append('dispatchTime', dispatchTimeWithoutSeconds);
      formData.append('content', data.content);
      formData.append('sendFromBaseParent', fromBaseParent)

      if (data.senderStaffOriginal) {
        formData.append('senderStaffOriginal', data.senderStaffOriginal);
      }

      if(data.crmMailsOriginalsToDelete) {
        Object.keys(data.crmMailsOriginalsToDelete).forEach((index) => {
          formData.append(`crmMailsOriginalsToDelete[${index}]`, data.crmMailsOriginalsToDelete[index]);
        });
      }
      
      if(data.newGroupsOfMailReceiverOriginalIds) {
        data.newGroupsOfMailReceiverOriginalIds.forEach((group, index) => {
          formData.append(`newGroupsOfMailReceiverOriginalIds[${index}]`, group);
        });
      }

      if(data.dynamicCrmGroups) {
        data.dynamicCrmGroups.forEach((group, index) => {
          formData.append(`dynamicCrmGroups[${index}]`, group);
        });
      }

      data.crmMails.forEach(((item, index) => {
            Object.keys(item).forEach(
              key => {
                if (item[key]) {
                  formData.append(`crmMails[${index}][${key}]`, item[key])
                }
              })
          })
      );

      if(data.uploadedFiles) {
        data.uploadedFiles.forEach(((item, index) => {
              Object.keys(item).forEach(
                key => {
                  formData.append(`uploadedFiles[${index}][${key}]`, key !== 'private' ? item[key] : (item.private ? '1' : '0'))
                })
            })
        );
      }

      if(data.newUploadedFiles) {
        data.newUploadedFiles.forEach(((file, index) => {
            formData.append(`newUploadedFiles[${index}][name]`, file.name);
            formData.append(`newUploadedFiles[${index}][private]`, file.private ? '1' : '0');
            formData.append(`newUploadedFiles[${index}][file]`, file.file);
          })
        );
      }

      return axios.post(`${ apiPaths.CRM }/mails`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    delete(id) {
        return axios.delete(`${ apiPaths.CRM }/mails/${ id }`);
    },
    getOriginalAttachments(id) {
        return axios.get(`${ apiPaths.CRM }/mails/${ id }/original-attachments`);
    }
};
